const useCompactDataTableStyles = (additionalStyles = {}) => {
  const defaultStyles = {
    rows: {
      style: {
        minHeight: "24px", // Altura mínima de las filas reducida
        backgroundColor: "transparent",
        color: "var(--ge-text, var(--bs-dark-text-emphasis))",
        "&:nth-of-type(odd)": {
          backgroundColor: "transparent",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "transparent",
        },
        "&:hover": {
          backgroundColor: "var(--ge-primary-light, var(--bs-secondary-bg-subtle))",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "transparent",
        color: "var(--ge-text-muted, #6c757d)",
        fontSize: "12px", // Tamaño de fuente más pequeño
        fontWeight: "700", // Negrita para el texto del encabezado
        textTransform: "uppercase",
        letterSpacing: "0.03em",
        border: "none",
        padding: "4px 8px", // Padding reducido
      },
    },
    cells: {
      style: {
        color: "var(--ge-text, var(--bs-heading-color))",
        fontSize: "12px", // Tamaño de fuente más pequeño
        fontWeight: "var(--bs-body-font-weight)",
        padding: "4px 8px", // Padding reducido
        border: "none",
        borderBottom: "1px solid var(--ge-border, var(--bs-light-border-subtle))",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "var(--ge-primary-light, var(--bs-secondary-bg-subtle))",
        },
      },
    },
    pagination: {
      style: {
        backgroundColor: "transparent",
        color: "var(--ge-text-muted, var(--bs-dark))",
        borderTop: "1px solid var(--ge-border, var(--bs-light-border-subtle))",
        fontSize: "12px", // Tamaño de fuente más pequeño
        padding: "4px", // Padding reducido
        minHeight: "32px", // Altura mínima reducida
      },
    },
    noData: {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        color: "var(--ge-text-muted, var(--bs-gray-500))",
        fontSize: "14px", // Tamaño de fuente reducido
      },
    },
    // Añade aquí otros estilos por defecto si es necesario
  };

  // Fusiona los estilos por defecto con los adicionales proporcionados
  return { ...defaultStyles, ...additionalStyles };
};

export default useCompactDataTableStyles;
